<template>
	<div class="page-wrapper1">
		<div class="row-1">
			<div class="row-1-item">
				<div style="">
					<img style="height: 30px;" src="../assets/favicon.png" />
				</div>
				<div class="ptclass">
					威海市市场监督管理局企业高质量发展服务平台·
					<el-button style="background-color: #004B99;color: #FFFFFF;" size="mini">
						{{ftype == '1' ? '个人工作室' : '企业工作室'}}
					</el-button>
				</div>
				<div class="goMainIndex" @click="toOpenPage('/main/index')">
					<i class="el-icon-s-home"></i>
					返回首页
				</div>
			</div>
		</div>
		<keep-alive>
		  <router-view />
		</keep-alive>
	</div>
</template>
<script>
	import CurrentDate from "@/components/CurrentDate";

	export default {
		name: 'Qygzs',
		components: {
			CurrentDate
		},
		computed: {
			loginToken() {
				return this.$store.state.user.token
			},
			getIndex() {
				let mainIndex = this.$store.state.activeMenu.mainIndex;
				return mainIndex;
			}
		},
		data() {
			return {
				activeIndex: '1',
				ftype:''
			}
		},
		created() {
			// console.log("getIndex()="+getIndex());
			let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			this.ftype = ssessionLogin.user.ftype;
		},
		methods: {
			toOpenPage(topath) {
				this.$router.push({
					path: topath
				})
				this.$store.commit('SET_MAININDEX', topath);
			},

		}
	}
</script>
<style scoped>
	.page-wrapper1{
		margin: auto;
		color:#303133;
		font-size: 14px;
		text-align: center;
		background-color: #EBEEF8;
		background-color: #FFFFFF;
		width:1300px;
	}
	.row-1 {
		display: flex;
		height: 60px;
		background-color: #FFFFFF;
	}

	.row-1-item {
		display: flex;
		flex: 1;
		padding: 15px;
		line-height: 30px;
		font-weight: bold;
		font-size: 20px;
	}

	/deep/.el-menu.el-menu--horizontal,
	/deep/.el-menu--horizontal>.el-menu-item,
	/deep/.el-menu--horizontal>.el-menu-item.is-active,
	/deep/.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
		border: 0px;
	}

	.el-menu--horizontal .el-menu-item {
		color: #000000;
	}

	.el-menu--horizontal .el-menu-item.is-active {
		color: #409eff;
	}

	/deep/.el-menu-item a {
		color: #000000;
	}

	/deep/.el-menu-item.is-active a:hover {
		color: #409eff;
	}

	.el-menu--horizontal>.el-submenu /deep/.el-submenu__title {
		color: #000000;
	}

	/deep/.el-submenu.is-active .el-submenu__title {
		color: #409eff;
	}

	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
		color: #409eff;
	}

	.consult {
		position: fixed;
		top: 45%;
		right: 5px;
		z-index: 999;
		cursor: pointer;
	}

	.consult img {
		width: 70px;
	}

	.goMainIndex {
		flex: 1;
		font-size: 15px;
		text-align: right;
		padding-right: 10px;
		color: #000000;
		cursor: pointer;
	}

	.ptclass {
		flex: 1;
		font-size: 18px;
		text-align: left;
		padding-left: 10px;
		color: #004B99;
	}
</style>
